import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  supplierDetails: {
    id: 'GJlZdF',
    defaultMessage: 'Supplier details',
    description: 'Header for the supplier details section in the purchase order page',
  },
  supplier: {
    id: 'BCZwbZ',
    defaultMessage: 'Supplier',
    description: 'Label for the supplier field in the supplier details section',
  },
  destination: {
    id: 'gTDRcZ',
    defaultMessage: 'Destination',
    description: 'Label for the destination field in the supplier details section',
  },
});
